<template>
  <div class="dialog-mask" v-if="visible">
    <div class="video-dialog">
      <div class="header">
        <p class="video-title">{{ info.title }}</p>
        <span class="close-btn" @click="closeDialog"></span>
      </div>
      <div class="content">
        <div class="video-img" v-if="info.imgUrl" v-show="!!countTime" :style="{ backgroundImage: `url(${info.imgUrl})` }">
          <div class="close-info" v-show="videoImgLoaded">{{ countTime }}s后观看回放</div>
        </div>

        <div class="video-box" v-if="testVideoSrc === 1" v-show="videoImgLoaded && !countTime">
          <video :src="info.url" width="100%" height="100%" controls controlslist="nodownload noremoteplayback" ref="video"></video>
        </div>
        <div class="video-box" v-else-if="testVideoSrc === 2" v-show="videoImgLoaded && !countTime">
          <video id="m3u8Video" width="100%" height="100%" class="video-js vjs-default-skin" controls>
            <source
              :src="info.url"
              type="application/x-mpegURL">
          </video>
        </div>
        <iframe
          v-else
          v-show="videoImgLoaded && !countTime"
          allowfullscreen
          :src="info.url"
          frameborder="0"
          scrolling="no"
          width="100%"
          height="100%"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['visible', 'info'],
  data() {
    return {
      videoImgLoaded: false,
      countTime: 3,
      imgTimer: null,
    }
  },
  computed: {
    videoSrc () {
      return this.info.url
    },
    testVideoSrc () {
      if (/\.flv\.mp4/.test(this.videoSrc)) {
        return 1
      }
      if (/\.m3u8/.test(this.videoSrc)) {
        return 2
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.imgTimer)
  },
  watch: {
    visible (status) {
      if (status) {
        this.initVideoImg()
      } else {
        clearTimeout(this.imgTimer)
        this.countTime = 3
        this.videoImgLoaded = false
      }
    },
    videoImgLoaded(status) {
      if (status && !!this.info.imgUrl) {
        this.imgInterval()
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },

    initVideoImg() {
      if (!this.info.imgUrl) {
        this.videoImgLoaded = true
        this.countTime = 0
        setTimeout(() => this.playVideo(), 100)
        return
      }
      const img = new Image()
      img.src = this.info.imgUrl
      img.onload = () => {
        this.videoImgLoaded = true
      }
      img.onerror = () => {
        this.videoImgLoaded = true
      }
    },

    imgInterval () {
      this.imgTimer = setInterval(() => {
        this.countTime--
        if (this.countTime === 0) {
          clearTimeout(this.imgTimer)
          this.imgTimer = null
          this.playVideo()
        }
      }, 1000)
    },

    async playVideo () {
      if (/\.m3u8/.test(this.videoSrc)) {
        try {
          await this.loadVideoJS()

          const video = videojs('m3u8Video', {
            autoplay: true,
            controlBar: {
              children: [
                { name: 'playToggle' }, // 播放按钮
                { name: 'progressControl' }, // 播放进度条
                { name: 'remainingTimeDisplay' }, // 当前已播放时间
                { name: 'VolumeControl' }, // 音量
                { name: 'fullscreenToggle' }, // 全屏播放
              ]
            }
          })
          video.play()
        } catch (err) {
          console.log(err)
        }
      } else {
        if (this.$refs.video) {
          this.$refs.video.disablePictureInPicture = true
          this.$refs.video.play()
        }
      }
    },
    loadVideoJS() {
      return new Promise(resolve => {
        const link = document.createElement('link')
        link.href = '//static0.xesimg.com/platform-fe/mall_www_pc/video-js.min.css'
        link.rel = 'stylesheet'
        document.head.appendChild(link)

        const script = document.createElement('script')
        script.src = '//static0.xesimg.com/platform-fe/mall_www_pc/video.min.js'
        document.body.appendChild(script)

        script.addEventListener('load', () => {
          resolve(true)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.video-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 804px;
  height: 596px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
}
.header {
  height: 30px;
  line-height: 30px;
  padding: 5px 35px 5px 15px;
  background: url(https://img04.xesimg.com/dialog/dialog_header.png);
  border-bottom: 1px solid #e5e5e5;
}
.content {
  // position: relative;
  // box-sizing: border-box;
  // width: 800px;
  // height: 550px;
  // min-width: 100px;
  // padding: 15px;
  // overflow: auto;

  position: relative;
  box-sizing: border-box;
  width: 800px;
  height: 550px;
  min-width: 100px;
  padding: 15px;
  overflow: auto;


  .video-img, .video-box {
    width: 770px;
    height: 520px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .video-img {
    z-index: 2;
    background-size: cover;
    background-color: #ffffff;
    .close-info {
      position: absolute;
      right: 22px;
      top: 30px;
      width: 164px;
      height: 40px;
      color: #FFFBEF;
      font-size: 20px;
      text-align: center;
      line-height: 40px;
      background-color: rgba($color: #000000, $alpha: 0.3);
      border-radius: 100px;
    }
  }

  .video-box {
    z-index: 1;
    background: #000000;
    .video-js {
      width: 100%;
      height: 100%;
    }

    video {
      outline: none;
    }
  }
}
.dialog-mask {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.close-btn {
  width: 15px;
  height: 15px;
  display: inline-block;
  position: absolute;
  right: 22px;
  top: 15px;
  z-index: 1001;
  overflow: hidden;
  text-indent: -2000px;
  background: url(//img04.xesimg.com/dialog/dialog_close_new.png) no-repeat left 0;
  &:hover {
    background: url(//img04.xesimg.com/dialog/dialog_close_hover.png) no-repeat left 0;
  }
}
.video-title {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// ./src/components/VideoDialog.vue